import React from "react";
import { SpinningLoader } from "risa-oasis-ui_v2";
import Pagination from "../pagination/pagination";
import { CellData } from "./table";
import TableBody from "./tableBody";

/** Table body and shared pagination-control configuration. */
interface TableWithPaginationProps {
  tableName: string;
  sortedTableHeaders: any[];
  computedCellData: CellData[][];
  tableDataToRender: any[];
  tableWidth: number;
  onSortTableData: (key: string, subKey?: string, type?: string) => void;
  onRowClick: (tableData: any[], rowIndex: number, className: string) => void;
  hidePagination?: boolean;
  count?: number;
  itemsPerPage?: number;
  pagesPerView?: number;
  handlePageChange: (
    startIndex: number,
    endIndex: number,
    data?: any[],
  ) => void;
  triggerHandlePageChange: number;
  paginationData: React.ReactNode;
  showInLineLoader?: boolean;
  onTableRowUpdate?: (
    rowIndex: number,
    fieldKey: string,
    newValue: any,
  ) => void;
  /** Fired when a CLICKABLE_BADGE_WITH_ON_CLICK cell is clicked; receives the cell `id`. */
  onClickableBadgeClick?: (id: string) => void;
  startIndex?: number;
  isPreviousButtonDisabled?: boolean;
  currentPage?: number;
  serverSidePagination?: boolean;
  onPageChange?: (page: number) => void;
  rowClassName?: string | ((rowData: any, rowIndex: number) => string);
}

/**
 * Table body plus optional pagination footer for RisaCustomTable.
 *
 * @param props - Page window data and pagination config
 * @returns Table + pagination
 */
const TableWithPagination: React.FC<TableWithPaginationProps> = (props) => {
  return (
    <>
      <div className="table">
        <table key={props.tableName}>
          <TableBody
            computedCellData={props.computedCellData}
            tableDataToRender={props.tableDataToRender}
            tableWidth={props.tableWidth}
            onRowClick={props.onRowClick}
            onTableRowUpdate={props.onTableRowUpdate}
            onClickableBadgeClick={props.onClickableBadgeClick}
            startIndex={props.startIndex}
            rowClassName={props.rowClassName}
          />
        </table>
      </div>
      {props.showInLineLoader && (
        <div className="table-loader mb-4 mr-4 flex items-center justify-end gap-2 text-small font-regular">
          <SpinningLoader />
          Loading Data ...
        </div>
      )}
      {!props.hidePagination && (
        <div className="table-pagination mt-4">
          {(props.count ?? 0) > 0 && (
            <>
              <Pagination
                itemsCount={props.count ?? 0}
                itemsPerPage={props.itemsPerPage ?? 0}
                pagesPerView={props.pagesPerView ?? 0}
                sendStartAndEndIndex={props.handlePageChange}
                triggerHandlePageChange={props.triggerHandlePageChange}
                tableName={props.tableName}
                isPreviousButtonDisabled={props.isPreviousButtonDisabled}
                currentPage={props.currentPage}
                serverSide={props.serverSidePagination}
                onPageChange={props.onPageChange}
              />
              <div className="pagination-details">{props.paginationData}</div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default TableWithPagination;
